import template from './denomination.edit.html';
import controller from './denomination.edit.controller';
import './denomination.edit.scss';

let denominationeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default denominationeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/edit/denomination.edit.component.js